import React from 'react';

import { withStyles } from '@material-ui/core/styles';

import grey from '@material-ui/core/colors/grey';

const styles = theme => ({
  root: {
    flexGrow: 1,
    maxWidth: '2px',
    minWidth: '2px',
    margin: '20px 10px',
    background: grey[300],
  },
});

const VerticalDivider = ({ classes }) => {
  return(
    <div className={classes.root} />
  );
};

export default withStyles(styles)(VerticalDivider);



// WEBPACK FOOTER //
// ./src/components/Dividers/VerticalDivider.jsx